module.exports = __webpack_public_path__ + "static/media/KG.99318e86.svg";